import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';

const PasswordEntry = ({ minCharacters = 8, onSuccess }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    if (values.password === values.confirmPassword) {
      onSuccess(values.password);
    } else {
      form.setFields([
        {
          name: 'confirmPassword',
          errors: ['The two passwords do not match!'],
        },
      ]);
    }
  };

  return (
    <Form form={form} onFinish={onFinish} layout="vertical">
      <Form.Item
        name="password"
        label="Password"
        rules={[
          { required: true, message: 'Please input your password!' },
          { min: minCharacters, message: `Password must be at least ${minCharacters} characters.` }
        ]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item
        name="confirmPassword"
        label="Confirm Password"
        dependencies={['password']}
        hasFeedback
        rules={[
          { required: true, message: 'Please confirm your password!' },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('The two passwords that you entered do not match!'));
            },
          }),
        ]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default PasswordEntry;
